import { useEffect, useState } from 'react';

/**
 * A wait indicator that does not flash.
 *
 * Most auth checks resolve in well under 200ms, and a spinner that appears and vanishes in
 * that time reads as a glitch rather than as progress - it makes a fast app feel unstable.
 * So nothing renders for the first 400ms; only a genuinely slow check gets an indicator.
 *
 * This is deliberately the ONLY indeterminate indicator in the product. Everywhere content has
 * a known shape, a skeleton of that shape is used instead - a spinner tells you to wait, a
 * skeleton tells you what you are waiting for.
 */
export function FullPageSpinner({ label }: { label: string }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="fullpage" role="status" aria-live="polite" aria-busy="true">
      {visible && (
        <>
          <span className="pulse" aria-hidden="true" />
          <span className="fullpage-label">{label}</span>
        </>
      )}
      <span className="sr-only">{label}</span>
    </div>
  );
}
